"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UploadError = exports.TotalFileSizeError = exports.FileTypeError = exports.FileSizeError = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _qs = _interopRequireDefault(require("qs"));

var _service = require("./service");

var _constants = require("@insided/deprecated-libs/constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var uniqueId = 0;

var FileSizeError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(FileSizeError, _Error);

  var _super = _createSuper(FileSizeError);

  function FileSizeError(allowedFileSize) {
    var _this;

    (0, _classCallCheck2.default)(this, FileSizeError);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "allowedFileSize", void 0);
    _this.allowedFileSize = allowedFileSize;
    return _this;
  }

  return (0, _createClass2.default)(FileSizeError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.FileSizeError = FileSizeError;

var TotalFileSizeError = /*#__PURE__*/function (_Error2) {
  (0, _inherits2.default)(TotalFileSizeError, _Error2);

  var _super2 = _createSuper(TotalFileSizeError);

  function TotalFileSizeError() {
    (0, _classCallCheck2.default)(this, TotalFileSizeError);
    return _super2.apply(this, arguments);
  }

  return (0, _createClass2.default)(TotalFileSizeError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.TotalFileSizeError = TotalFileSizeError;

var UploadError = /*#__PURE__*/function (_Error3) {
  (0, _inherits2.default)(UploadError, _Error3);

  var _super3 = _createSuper(UploadError);

  function UploadError(attachmentId) {
    var _this2;

    (0, _classCallCheck2.default)(this, UploadError);
    _this2 = _super3.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "attachmentId", void 0);
    _this2.attachmentId = attachmentId;
    return _this2;
  }

  return (0, _createClass2.default)(UploadError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.UploadError = UploadError;

var FileTypeError = /*#__PURE__*/function (_Error4) {
  (0, _inherits2.default)(FileTypeError, _Error4);

  var _super4 = _createSuper(FileTypeError);

  function FileTypeError(attachmentId) {
    var _this3;

    (0, _classCallCheck2.default)(this, FileTypeError);
    _this3 = _super4.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "attachmentId", void 0);
    _this3.attachmentId = attachmentId;
    return _this3;
  }

  return (0, _createClass2.default)(FileTypeError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.FileTypeError = FileTypeError;

function isImageType(type) {
  var imageTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/webp', 'png', 'jpg', 'jpeg', 'gif', 'webp'];
  var imageTypesTreatedAsNotImages = ['image/x-sony-arw', 'image/x-canon-cr2', 'image/x-canon-cr3', 'image/x-canon-crw', 'image/x-adobe-dng', 'image/x-nikon-nef', 'image/x-nikon-nrw', 'image/x-olympus-orf', 'image/vnd.adobe.photoshop', 'image/x-fuji-raf', 'image/x-panasonic-raw', 'image/x-panasonic-rw', 'image/x-panasonic-rw2', 'image/x-pentax-pef', 'image/x-minolta-mrw', 'image/x-kodak-dcr', 'image/x-kodak-kdc', 'image/x-raw', 'image/x-samsung-srw', 'image/x-sigma-x3f', 'image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence', 'image/x-eps', 'image/eps', 'image/svg+xml', 'image/raw', 'image/x-dcraw', 'image/x-portable-anymap', 'image/tiff'];
  if (imageTypes.includes(type)) return true;
  if (imageTypesTreatedAsNotImages.includes(type)) return false;
  return type.indexOf('image') === 0;
}

var AttachmentUploader = /*#__PURE__*/function () {
  function AttachmentUploader() {
    (0, _classCallCheck2.default)(this, AttachmentUploader);
    (0, _defineProperty2.default)(this, "maxCombinedAttachmentsSize", void 0);
    (0, _defineProperty2.default)(this, "maxAttachmentSize", void 0);
    (0, _defineProperty2.default)(this, "maxImageSize", void 0);
    (0, _defineProperty2.default)(this, "totalAttachmentSize", void 0);
    this.maxCombinedAttachmentsSize = 104857600; // 100Mb

    this.maxAttachmentSize = 52428800; // 50Mb

    this.maxImageSize = _constants.maxImageFileSize;
    this.totalAttachmentSize = 0;
  }
  /* eslint-disable class-methods-use-this */


  (0, _createClass2.default)(AttachmentUploader, [{
    key: "getUniqueAttachmentId",
    value: function getUniqueAttachmentId() {
      return uniqueId++;
    }
  }, {
    key: "getType",
    value: function getType(file) {
      if (isImageType(file.type)) {
        return 'image';
      }

      return file.name.split('.').pop();
    }
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(attachmentId, file) {
        var regex, newFile;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isImageType(file.type)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this._uploadImage(attachmentId, file);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
                regex = /[?+#]/;
                newFile = file;

                if (!regex.test(file.name)) {
                  _context.next = 10;
                  break;
                }

                throw new FileTypeError(attachmentId);

              case 10:
                newFile = new File([file], encodeURIComponent(file.name), {
                  type: file.type
                });

              case 11:
                _context.next = 13;
                return this._uploadFileToS3(attachmentId, newFile);

              case 13:
                return _context.abrupt("return", _context.sent);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadFile(_x, _x2) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "formatMaxFileSize",
    value: function formatMaxFileSize(bytes) {
      return new Intl.NumberFormat('en-US', {
        style: 'unit',
        unit: 'megabyte'
      }).format(bytes / (1024 * 1024));
    }
  }, {
    key: "_uploadImage",
    value: function () {
      var _uploadImage2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(attachmentId, file) {
        var tokenEl, csrfToken, formData, data;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tokenEl = document.getElementById('csrftoken');
                csrfToken = tokenEl === null || tokenEl === void 0 ? void 0 : tokenEl.value;

                if (!(file.size && file.size > this.maxImageSize)) {
                  _context2.next = 4;
                  break;
                }

                throw new FileSizeError(this.formatMaxFileSize(this.maxImageSize));

              case 4:
                formData = new window.FormData();
                formData.append('image', file);
                formData.append('yip_csrf_token', csrfToken);
                _context2.prev = 7;
                _context2.next = 10;
                return (0, _service.uploadImage)(formData);

              case 10:
                data = _context2.sent;
                return _context2.abrupt("return", {
                  source: data.source,
                  source_thumb: data.source_thumb
                });

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](7);
                throw new UploadError(attachmentId);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 14]]);
      }));

      function _uploadImage(_x3, _x4) {
        return _uploadImage2.apply(this, arguments);
      }

      return _uploadImage;
    }()
  }, {
    key: "_uploadFileToS3",
    value: function () {
      var _uploadFileToS = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(attachmentId, file) {
        var fileType, fileData, tags;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(file.size && file.size > this.maxAttachmentSize)) {
                  _context3.next = 2;
                  break;
                }

                throw new FileSizeError(this.formatMaxFileSize(this.maxAttachmentSize));

              case 2:
                if (!(this.totalAttachmentSize + (file.size || 0) > this.maxCombinedAttachmentsSize)) {
                  _context3.next = 4;
                  break;
                }

                throw new TotalFileSizeError();

              case 4:
                this.totalAttachmentSize += file.size || 0;
                fileType = this.getFileType(file);
                _context3.prev = 6;
                _context3.next = 9;
                return (0, _service.getSignedUrl)(file.name, fileType);

              case 9:
                fileData = _context3.sent;
                tags = _qs.default.parse(fileData.url, {
                  ignoreQueryPrefix: true
                })['x-amz-tagging'];
                _context3.next = 13;
                return (0, _service.uploadFileToS3)(fileData.url, file, fileType, tags);

              case 13:
                return _context3.abrupt("return", fileData);

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](6);

                if (!(_context3.t0.response.data === 'File extension is not allowed')) {
                  _context3.next = 20;
                  break;
                }

                throw new FileTypeError(attachmentId);

              case 20:
                throw new UploadError(attachmentId);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 16]]);
      }));

      function _uploadFileToS3(_x5, _x6) {
        return _uploadFileToS.apply(this, arguments);
      }

      return _uploadFileToS3;
    }()
  }, {
    key: "getFileType",
    value: function getFileType(file) {
      var EXTENSION_TO_MIME = {
        '8bf': 'application/octet-stream',
        abf: 'application/octet-stream',
        act: 'application/octet-stream',
        afm: 'application/x-font-afm',
        as: 'application/ecmascript',
        ase: 'application/octet-stream',
        book: 'application/octet-stream',
        cel: 'application/octet-stream',
        cfc: 'application/x-coldfusion',
        chproj: 'application/octet-stream',
        cptx: 'application/octet-stream',
        crf: 'application/octet-stream',
        dn: 'application/octet-stream',
        exif: 'application/octet-stream',
        fbx: 'application/octet-stream',
        fla: 'application/octet-stream',
        fm: 'application/octet-stream',
        icma: 'application/octet-stream',
        icml: 'application/vnd.adobe.indesign-template',
        ics: 'text/calendar',
        idml: 'application/vnd.adobe.indesign-idml',
        indd: 'application/x-indesign',
        loss: 'application/octet-stream',
        lrcat: 'application/octet-stream',
        lrtemplate: 'application/octet-stream',
        mif: 'application/vnd.mif',
        otc: 'application/vnd.oasis.opendocument.chart-template',
        pfb: 'application/x-font-pfb',
        pfm: 'application/x-font-type1',
        pmd: 'application/octet-stream',
        ppj: 'application/octet-stream',
        prc: 'application/x-mobipocket-ebook',
        prel: 'application/octet-stream',
        psap: 'application/octet-stream',
        sbs: 'application/octet-stream',
        sbsar: 'application/octet-stream',
        sbsm: 'application/octet-stream',
        scc: 'application/octet-stream',
        ses: 'application/octet-stream',
        sesx: 'application/octet-stream',
        skp: 'application/vnd.sketchup.skp',
        sol: 'application/octet-stream',
        ssa: 'text/x-ssa',
        stl: 'model/stl',
        ttc: 'font/collection',
        abr: 'application/vnd.adobe.photoshop.brush',
        aep: 'application/vnd.adobe.aftereffects.project',
        ai: 'application/postscript',
        eps: 'application/postscript',
        ps: 'application/postscript',
        psd: 'image/vnd.adobe.photoshop',
        psb: 'image/vnd.adobe.photoshop',
        prproj: 'application/vnd.adobe.premiere.project',
        xd: 'application/vnd.adobe.xd',
        xmp: 'application/rdf+xml',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        bmp: 'image/bmp',
        tif: 'image/tiff',
        tiff: 'image/tiff',
        svg: 'image/svg+xml',
        heic: 'image/heic',
        dng: 'image/x-adobe-dng',
        arw: 'image/x-sony-arw',
        cr2: 'image/x-canon-cr2',
        cr3: 'image/x-canon-cr3',
        crw: 'image/x-canon-crw',
        nef: 'image/x-nikon-nef',
        nrw: 'image/x-nikon-nrw',
        olf: 'application/olf',
        orf: 'image/x-olympus-orf',
        srw: 'image/x-samsung-srw',
        raf: 'image/x-fuji-raf',
        x3f: 'image/x-sigma-x3f',
        avi: 'video/x-msvideo',
        mov: 'video/quicktime',
        mp4: 'video/mp4',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mp3: 'audio/mpeg',
        wav: 'audio/wav',
        flac: 'audio/flac',
        m4a: 'audio/mp4',
        pdf: 'application/pdf',
        epub: 'application/epub+zip',
        rtf: 'application/rtf',
        odt: 'application/vnd.oasis.opendocument.text',
        jsfl: 'application/javascript',
        json: 'application/json',
        log: 'text/plain',
        srt: 'text/plain',
        cpd: 'application/octet-stream',
        gz: 'application/gzip',
        'tar.gz': 'application/gzip',
        har: 'application/json',
        odp: 'application/vnd.oasis.opendocument.presentation',
        ods: 'application/vnd.oasis.opendocument.spreadsheet',
        pps: 'application/vnd.ms-powerpoint',
        rar: 'application/vnd.rar',
        rm: 'application/vnd.rn-realmedia',
        xlr: 'application/vnd.ms-works',
        z: 'application/x-compress',
        '7z': 'application/x-7z-compressed',
        ioc: 'application/octet-stream',
        hex: 'text/plain',
        c: 'text/x-c',
        cc: 'text/x-c++',
        cpp: 'text/x-c++',
        h: 'text/x-c',
        hpp: 'text/x-c++',
        tar: 'application/x-tar',
        xz: 'application/x-xz',
        dts: 'audio/vnd.dts',
        s: 'text/x-asm'
      };
      var fileType = file.type;

      if (!fileType) {
        var _file$name;

        var match = (_file$name = file.name) === null || _file$name === void 0 ? void 0 : _file$name.toLowerCase().match(/\.([a-z0-9]+)$/);

        if (match && match[1] in EXTENSION_TO_MIME) {
          var ext = match[1];
          fileType = EXTENSION_TO_MIME[ext];
        }
      }

      return fileType;
    }
  }]);
  return AttachmentUploader;
}();

var _default = AttachmentUploader;
exports.default = _default;